import React from 'react';
import Form from 'react-bootstrap/Form';
import { IconButton, TextField } from '@material-ui/core';
import { useStyle } from './styles';
import { getIn } from 'formik';
import styles from './ValidatedFormInputField.module.css';
import HelperText from '../HelperText';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FormHelperTextComponent = ({ children }) => <HelperText>{children}</HelperText>;

FormHelperTextComponent.propTypes = {
    children: PropTypes.node,
};

const ValidatedFormInputField = React.forwardRef(
    (
        {
            value,
            field,
            form,
            label,
            regex,
            max,
            handleChange,
            StartAdornmentIcon,
            EndAdornmentIcon,
            onEndAdornmentClick,
            onFocus,
            onBlur,
            ...props
        },
        ref
    ) => {
        const classes = useStyle();
        const { touched, errors, values } = form;

        const fieldError = getIn(errors, field.name);
        const isInvalid = Boolean(fieldError) && Boolean(getIn(touched, field.name));

        const handleInputChange = (event) => {
            if (props.onChange) {
                props.onChange(event);
                return;
            }
            const nextValue = event.target.value.replace(regex, '').slice(0, max);
            form.setFieldValue(field.name, nextValue);
            handleChange?.(nextValue);
        };

        return (
            <Form.Group className={classNames(styles.formInputWrapper, props.className)}>
                {label && <Form.Label>{label}</Form.Label>}
                <TextField
                    {...props}
                    fullWidth
                    name={field?.name}
                    value={value || values[field.name]}
                    error={isInvalid}
                    FormHelperTextProps={{ component: FormHelperTextComponent }}
                    helperText={isInvalid && fieldError}
                    onChange={handleInputChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    ref={ref}
                    inputProps={{
                        maxLength: props.maxLength,
                    }}
                    InputProps={{
                        classes: {
                            root: classes.inputRoot,
                            input: classes.inputField,
                            error: classes.error,
                            notchedOutline: classes.notchedOutline,
                            focused: classes.focused,
                            disabled: classes.disabled,
                        },
                        startAdornment: StartAdornmentIcon && <StartAdornmentIcon />,
                        endAdornment: values[field.name]?.length > 0 && EndAdornmentIcon && (
                            <IconButton
                                onClick={onEndAdornmentClick}
                                className={styles.endAdornmentButton}
                            >
                                <EndAdornmentIcon className={styles.endAdornmentIcon} />
                            </IconButton>
                        ),
                    }}
                />
            </Form.Group>
        );
    }
);

ValidatedFormInputField.propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
    label: PropTypes.string,
    regex: PropTypes.string,
    max: PropTypes.number,
    StartAdornmentIcon: PropTypes.elementType,
    EndAdornmentIcon: PropTypes.elementType,
    handleChange: PropTypes.func,
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onEndAdornmentClick: PropTypes.func,
};

export default ValidatedFormInputField;
